import { defineStore } from "pinia";
import { apolloClient } from "@/apollo/client";
import gql from "graphql-tag";
import jwtDecode from "jwt-decode";



export const useAuthStore = defineStore("auth", {
    namespaced: true,

    state: () => ({
        user: {
            name: null,
            id: null,
            email: null,
            roles: []
        },
        access_token: null,
        refresh_token: null,


        refresh_interval_id: null,
    }),

    getters: {
        headers(state) {
            return {
                "Authorization": "Bearer " + state.access_token,
            }
        },

        ufficioOrMore(state) {
            if (state.user.roles.includes("office") || state.user.roles.includes("manager") || state.user.roles.includes("admin")) {
                return true
            }
            return false
        },

        isAuthenticated(state) {

            if (state.user.id != null) {
                return true
            }

            return false

        },


        access_token_exp_date(state) {

            if (state.access_token == null) return

            let tokenDecoded = jwtDecode(state.access_token)

            let exp = new Date(tokenDecoded.exp * 1000)

            return exp
        },
        refresh_token_exp_date(state) {

            if (state.refresh_token == null) return

            let tokenDecoded = jwtDecode(state.refresh_token)

            let exp = new Date(tokenDecoded.exp * 1000)

            return exp
        },
    },

    actions: {

        

        async checkCredentials(username, password) {


            let response = await apolloClient.query({
                query: gql`
                    query checkUser($password: String = "",$username: String = "", ) {
                        CheckCredenitlas(arg: {password: $password, username: $username}) {
                            message
                            status
                        }
                    }
                `,
                variables: {
                    username: username,
                    password: password
                }
            })

            return { message: response.data.CheckCredenitlas.message, status: response.data.CheckCredenitlas.status }

        },


        refresh_access_token() {
             return apolloClient.query({
                query: gql`
                    query refreshToken($refresh_token: String = "") {
                        user_refresh(arg: {refresh: $refresh_token}) {
                            access
                        }
                    }
                `,
                variables: {
                    refresh_token: this.refresh_token
                }
            }).then((response) => {


                let access_token = response.data.user_refresh.access

                this.access_token = access_token

                this.decodeToken(access_token)
            }).catch((error) => {
                console.error(error)
                this.logout()
            })
        },

        async setIntervalRefreshToken() {


            if (this.refresh_interval_id != null) {
                clearInterval(this.refresh_interval_id)
                this.refresh_interval_id = null
            }

            await this.refresh_access_token()

            let accessTokenDecoded = jwtDecode(this.access_token)


            let now = Date.now().valueOf()
            let exp = accessTokenDecoded.exp * 1000

            let delta = Math.floor((exp - now) / 1000)
            let minutes = Math.floor(delta / 60)

            console.log("Refresh token interval set to: " + minutes + " minutes")

            let id = setInterval(this.refresh_access_token, (minutes - 2) * 60 * 1000)
            this.refresh_interval_id = id

        },

        decodeToken(token) {

            let tokenDecoded = jwtDecode(token)

            this.user.id = tokenDecoded.user_id
            this.user.name = tokenDecoded.user_name
            this.user.email = tokenDecoded.user_email

            this.user.roles = tokenDecoded["https://hasura.io/jwt/claims"]["x-hasura-allowed-roles"]
        },

        async login(username, password) {

            let response = await apolloClient.query({
                query: gql`
                    query userLogin($username: String = "", $password: String = ""){
                        user_login(arg: {password:  $password, username: $username}) {
                            access
                            refresh
                    }  
                }
                `,
                variables: {
                    username: username,
                    password: password
                }
            })

            //console.log(response)
            //console.log(response.data.user_login.access)
            //console.log(response.data.user_login.refresh)

            this.access_token = response.data.user_login.access
            this.refresh_token = response.data.user_login.refresh

            localStorage.setItem("refreshToken", response.data.user_login.refresh)

            this.decodeToken(this.access_token)

            this.setIntervalRefreshToken()


            return true
        },

        async checkAuth() {

            if (this.refresh_token != null) {
                return
            }



        },

        logout() {

            //console.warn("logout")

            localStorage.removeItem("refreshToken")

            location.reload()

        },
    },
});